module.exports = __webpack_public_path__ + "static/media/NYAS.7fe56e5d.png";